/* @flow strict */

import * as React from 'react';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';

const refundAllBanner = (): React.Element<> => {
    const context = React.useContext(DefaultContainerContext);
    const email = _.get(context, 'profileCurrent.email', '');

    return (
        <div>
            <h4>Refund started</h4>
            <div>
                We have started refunding all tickets for this event.
                This task will take a while, we will notify you at <b>{email}</b> when it is done.
            </div>
        </div>
    );
};

export default refundAllBanner;